var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b5556afb00ab0e76aed69fd7db1937ce46ced9ce"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["nx_planner@routal"]={id:"b5556afb00ab0e76aed69fd7db1937ce46ced9ce"};
      